import { createHashHistory, createMemoryHistory } from 'history';

const TEST = process.env.NODE_ENV === 'test';
export default TEST ? createMemoryHistory() : createHashHistory();
